import Axios from "axios";
import {
  SET_LATE_EARLY_REPORT,
  UNSET_LATE_EARLY_REPORT,
} from "@/store/mutation-types";
import {
  getLateEarlyReport,
} from "@/store/api";

const state = {
  lateEarlyReport: [],
};

const getters = {
  getLateEarlyReport(state) {
    return state.lateEarlyReport;
  },
};

const mutations = {
  [SET_LATE_EARLY_REPORT](state, data) {
    state.lateEarlyReport = data;
  },
  [UNSET_LATE_EARLY_REPORT](state) {
    state.lateEarlyReport = [];
  },
};

const actions = {
  getLateEarlyReport({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(`${getLateEarlyReport}`, { params: data })
        .then((response) => {
          commit(SET_LATE_EARLY_REPORT, response.data.data || []);
          resolve(response.data);
        })
        .catch((error) => {
          commit(UNSET_LATE_EARLY_REPORT);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

